import React from 'react';
import { ArrowRight, Play, BookOpen } from 'lucide-react';
import PrimaryButton from '../components/PrimaryButton';
import SecondaryButton from '../components/SecondaryButton';
import EmailCapture from '../components/EmailCapture';
import { articles } from '../mock';

const Home = () => {
  const featuredArticles = articles.slice(0, 3);

  return (
    <div className="page-container">
      {/* Hero Section with Logo */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-logo-container">
              <img src="/praise-iam-logo.png" alt="Praise I AM Apologetics Logo" className="hero-logo" />
            </div>
            <h1 className="display-huge hero-title">
              DEFENDING BIBLICAL CHRISTIANITY — BY FREE GRACE
            </h1>
            <p className="body-large hero-subtitle">
              Apologetics. Free Grace Theology. Philosophy. Prophecy.
            </p>
            <div className="hero-buttons">
              <PrimaryButton to="/debates" icon={Play}>
                Watch Debates
              </PrimaryButton>
              <SecondaryButton to="/free-grace" icon={ArrowRight}>
                Explore Free Grace
              </SecondaryButton>
            </div>
          </div>

       </div>
      </section>

      {/* Email Capture */}
      <section className="section-container">
        <EmailCapture 
          source="homepage-essentials"
          title="Join Free For Premium Content"
          subtitle="Get exclusive Free Grace theology debates, articles, and apologetics resources delivered to your inbox."
        />
      </section>

      {/* Free Grace Essentials */}
      <section className="section-container">
        <h2 className="display-medium section-title">Free Grace Essentials</h2>
        <div className="essentials-grid">
          <div className="essential-card">
            <h3 className="heading-3">Salvation by Grace Through Faith Alone</h3>
            <p className="body-medium">
              Eternal life is a free, irrevocable gift received by faith alone in Christ alone, 
              apart from works or personal merit.
            </p>
          </div>
          <div className="essential-card">
            <h3 className="heading-3">Eternal Security</h3>
            <p className="body-medium">
              Once saved, always saved. Those who believe in Christ possess eternal life 
              that cannot be lost.
            </p>
          </div>
          <div className="essential-card">
            <h3 className="heading-3">Distinction: Salvation vs Discipleship</h3>
            <p className="body-medium">
              Salvation is by faith alone. Discipleship involves obedience and faithful service. 
              They are not the same.
            </p>
          </div>
        </div>
        <div className="section-cta">
          <SecondaryButton to="/free-grace" icon={ArrowRight}>
            Learn More About Free Grace
          </SecondaryButton>
        </div>
      </section>

      {/* Recent Articles */}
      <section className="section-container">
        <h2 className="display-medium section-title">Recent Articles</h2>
        <div className="articles-grid">
          {featuredArticles.map((article) => (
            <div key={article.id} className="article-card">
              <span className="article-category">{article.category}</span>
              <h3 className="heading-3">{article.title}</h3>
              <p className="body-medium article-excerpt">{article.excerpt}</p>
              <div className="article-meta">
                <span className="body-small">{article.readTime}</span>
                <span className="body-muted">{article.date}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="section-cta">
          <SecondaryButton to="/articles" icon={BookOpen}>
            View All Articles
          </SecondaryButton>
        </div>
      </section>

      {/* Popular Topics */}
      <section className="section-container">
        <h2 className="display-medium section-title">Popular Topics</h2>
        <div className="topics-grid">
          <div className="topic-card">
            <h3 className="heading-3">Trinity</h3>
            <p className="body-medium">Defending the biblical doctrine of the Triune God</p>
          </div>
          <div className="topic-card">
            <h3 className="heading-3">Resurrection</h3>
            <p className="body-medium">Historical evidence for Christ's bodily resurrection</p>
          </div>
          <div className="topic-card">
            <h3 className="heading-3">Salvation</h3>
            <p className="body-medium">Understanding the Free Grace Gospel</p>
          </div>
          <div className="topic-card">
            <h3 className="heading-3">Eternal Life</h3>
            <p className="body-medium">The free gift vs earned rewards</p>
          </div>
        </div>
      </section>

      {/* Email Capture */}
      <section className="section-container">
        <EmailCapture 
          source="homepage"
          title="Stay Connected with Praise I AM"
          subtitle="Join our community and receive updates on new debates, articles, and Free Grace theology resources. Be the first to know about upcoming livestreams and exclusive content."
        />
      </section>
    </div>
  );
};

export default Home;
